import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../Hooks/useAuth";
import Page403 from "../../Pages/Page403";
import logger from "../../utils/logger";

// Panelin tanıdığı roller. Bunların dışında bir rol taşıyan oturum bu
// uygulamaya ait DEĞİLDİR (ör. localStorage'da başka bir uygulamadan kalan
// "auth" kaydı — sahada role: "ClinicStaff" ile karşılaşıldı). Böyle bir
// oturumda kullanıcı HER route'tan reddedilir ve hiçbir sayfaya —Profil'e
// bile— gidemediği için 403/404 ekranına kilitlenir. Bunu yetki sorunu gibi
// göstermek yerine oturumu geçersiz sayıp login'e atıyoruz.
// Müşteri (customer) panele giremez (Server #341) — eski müşteri oturumu da
// login'e düşer.
const KNOWN_PANEL_ROLES = ["storage", "admin", "dealer"];

const RequireAuth = ({ allowedRoles }) => {
  const { auth } = useAuth();
  const location = useLocation();

  const isTokenExpired = (token) => {
    try {
      const base64Url = token.split(".")[1];
      if (!base64Url) return false;
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const payload = JSON.parse(
        decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`)
            .join("")
        )
      );
      if (!payload?.exp) return false;
      return payload.exp * 1000 <= Date.now();
    } catch (error) {
      return false;
    }
  };

  // Kimlik doğrulama (oturum geçerli mi) ile yetkilendirme (rol uygun mu) ayrı
  // ele alınır. Aksi halde giriş yapmış ama rolü uymayan kullanıcı "/"'a push
  // edilince login ↔ korumalı route arasında sonsuz yönlendirme döngüsüne
  // giriyordu (Maximum update depth / navigation throttling).
  const hasValidSession =
    auth?.accessToken && !isTokenExpired(auth.accessToken);
  // DB'deki role/subRole değeri her zaman beklenen küçük harf enum'la
  // birebir eşleşmeyebilir (ör. bozuk/eski kayıt) — case-insensitive kontrol
  // ediyoruz ki böyle bir kayıt kullanıcıyı tüm panelden kilitlemesin.
  const allowedRolesLower = allowedRoles?.map((r) => r?.toLowerCase());
  const roleAllowed =
    allowedRolesLower?.includes(auth?.role?.toLowerCase()) ||
    allowedRolesLower?.includes(auth?.subRole?.toLowerCase());

  // Oturum yok/expired → login'e (replace ile; history flooding olmaz)
  if (!hasValidSession) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Bu panele ait olmayan rol → oturumu temizle ve login'e. Yetki reddi
  // DEĞİL: kullanıcı hiçbir sayfaya giremez, 403'te kilitli kalırdı.
  const roleKnown = KNOWN_PANEL_ROLES.includes(
    String(auth?.role || "").toLowerCase(),
  );
  if (!roleKnown) {
    logger.warn("[RequireAuth] panele ait olmayan rol — oturum temizleniyor", {
      role: auth?.role,
      pathname: location.pathname,
    });
    try {
      localStorage.removeItem("auth");
    } catch (_) {
      /* storage kapalı olabilir — yönlendirme yine de yapılır */
    }
    return <Navigate to="/" replace />;
  }

  // Şifre değiştirme zorunlu → login akışına
  if (auth?.mustChangePassword === true) {
    return <Navigate to="/" replace />;
  }

  // Giriş yapılmış ama bu route'un rolüne yetkisi yok → 403 (yönlendirme YOK,
  // döngü oluşmaz). Önceden Page404 render ediliyordu: durum yanlıştı (sayfa
  // var, rol yetmiyor) ve YERİNDE render edildiği için URL değişmiyordu —
  // kullanıcı "404 → Girişe Dön → yine 404" döngüsünde kalıyordu.
  if (!roleAllowed) {
    logger.warn("[RequireAuth] rol reddedildi:", {
      pathname: location.pathname,
      allowedRoles,
      role: auth?.role,
      subRole: auth?.subRole,
      hasValidSession,
    });
    return <Page403 />;
  }

  return <Outlet />;
};

export default RequireAuth;
